import { render, staticRenderFns } from "./SelectProductBuild.vue?vue&type=template&id=622f0485&scoped=true&"
import script from "./SelectProductBuild.vue?vue&type=script&lang=js&"
export * from "./SelectProductBuild.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductBuild.vue?vue&type=style&index=0&id=622f0485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f0485",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VLayout})
